// CameraOverlay.js - Corner brackets for camera framing
import React from 'react';

export function CameraOverlay({ className = '', showHint = true }) {
  // SVG corner brackets - minimalist L-shaped corners
  // Positioned at each corner of a centered square frame
  // White with slight shadow for visibility on any background

  return (
    <div className={`absolute inset-0 pointer-events-none ${className}`}>
      {/* Top-left corner */}
      <svg className="absolute top-8 left-8 w-12 h-12 text-white drop-shadow-lg" viewBox="0 0 48 48" fill="none">
        <path d="M4 44V4H44" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>

      {/* Top-right corner */}
      <svg className="absolute top-8 right-8 w-12 h-12 text-white drop-shadow-lg" viewBox="0 0 48 48" fill="none">
        <path d="M44 44V4H4" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>

      {/* Bottom-left corner */}
      <svg className="absolute bottom-8 left-8 w-12 h-12 text-white drop-shadow-lg" viewBox="0 0 48 48" fill="none">
        <path d="M4 4V44H44" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>

      {/* Bottom-right corner */}
      <svg className="absolute bottom-8 right-8 w-12 h-12 text-white drop-shadow-lg" viewBox="0 0 48 48" fill="none">
        <path d="M44 4V44H4" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>

      {/* Center hint text - only shows when enabled */}
      {showHint && (
        <div className="absolute inset-0 flex items-center justify-center">
          <p className="text-white/60 text-sm font-medium tracking-wide">
            Position yourself within the frame
          </p>
        </div>
      )}
    </div>
  );
}

export default CameraOverlay;
